import RouterTabs from './tabs';

export default RouterTabs;